// Loaded with the module so its logout cleanup is registered even before any push UI mounts.
import '../services/push-subscription-service';
import notificationApiImpl from '../api/notification-api';
import type { NotificationApi } from './contracts';

export type {
  NotificationApplication,
  NotificationChannel,
  Subscription,
  Topic,
  UserNotification,
  WidgetNotification,
  NotificationApi,
  NotificationStatusFilter,
} from './contracts';
export { describeTagFilter } from '../model/subscription-coverage';
export { default as useNotificationSubscription } from '../hooks/use-notification-subscription';
export {
  NotificationServiceContextProvider,
  useNotificationServiceContext,
} from '../contexts/notification-service-context';
export {
  NotificationProvider,
  default as useWidgetNotifications,
} from '../contexts/widget-notification-context';
export { default as NotificationBell } from '../components/inbox/notification-bell';
export { STATUS_OPTIONS } from '../components/inbox/notification-filter-panel';
export { default as NotificationInboxEntry } from '../components/inbox/notification-inbox-entry';
export { default as PushEnablePrompt } from '../components/push-enable-prompt';
export { default as ContactsSection } from '../components/settings/contacts-section';
export { default as ProfileSection } from '../components/settings/profile-section';
export { default as SubscriptionList } from '../components/settings/subscriptions/subscription-list';
export { default as FieldValuesSummary } from '../components/subscribe-button/field-values-summary';
export { default as TopicSubscribeButton } from '../components/subscribe-button/topic-subscribe-button';
export { default as SubscriptionWizardModal } from '../components/subscription-wizard/subscription-wizard-modal';
export { default as VerifyContactPage } from '../pages/verify-contact-page';
export const notificationApi: NotificationApi = notificationApiImpl;
